import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import dayjs from "dayjs";
import React from "react";
import { useTSelector } from "rx/store";

const GpsStateContent: React.FC = () => {
  const tracks = useTSelector((s) => s.tracks);
  const teamsData = useTSelector((s) => s.teamsData);
  const teams = useTSelector((s) => s.teamsList);
  console.log("hmm1");
  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Team</TableCell>
            <TableCell>Dev</TableCell>
            <TableCell>Model</TableCell>
            <TableCell>App</TableCell>
            <TableCell>GPS points</TableCell>
            <TableCell>First</TableCell>
            <TableCell>Last</TableCell>
            <TableCell>Speed</TableCell>
            <TableCell>Acc</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {Object.entries(teams).map(([tid, team]) => {
            //console.log(k, v);
            if (!team.devs) {
              return <TableRow>
                <TableCell>{team.name}</TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
              </TableRow>;
            }
            const devs = Object.keys(team.devs);
            return devs.map((dk, index) => {
              const track = tracks[tid]?.[dk] ?? [];
              return (
                <TableRow>
                  {index === 0 && (
                    <TableCell rowSpan={devs.length}>
                      {team.name}
                    </TableCell>
                  )}
                  <TableCell>{dk}</TableCell>
                  <TableCell>{teamsData[tid]?.devs?.[dk]?.model ?? (teamsData[tid]?.devs ? "" : "No dev data")}</TableCell>
                  <TableCell>{
                    teamsData[tid]?.devs?.[dk]?.pkginfo?.appVersion ??
                    teamsData[tid]?.devs?.[dk]?.appversionname ??
                    ""}</TableCell>
                  <TableCell>{track.length}</TableCell>
                  <TableCell>
                    {track.length > 0 && dayjs(track[0].t).format("DD/MM/YYYY HH:mm:ss")}
                  </TableCell>
                  <TableCell>
                    {track.length > 0 && dayjs(track[track.length - 1].t).format(
                      "DD/MM/YYYY HH:mm:ss"
                    )}
                  </TableCell>
                  <TableCell>{track.length > 0 && track[0].s}</TableCell>
                  <TableCell>{track.length > 0 && track[0].a}</TableCell>
                </TableRow>
              );
            });
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default GpsStateContent;
